import { MainProductData } from '../../types';
import { StyledMainProduct } from '../style';
import {
    formattingNumber,
    calculateSaleStrokedNumber
} from '../../../Helper/utils/utils';

function BundleMainProduct({
    quantity = 100,
    images = { product: '' },
    salePercentage = 0,
    amountBeforeSale,
    quantityDisplay,
    quantityFormant,
    salePercentageDisplayType
}: MainProductData) {
    return (
        <StyledMainProduct title={quantityDisplay}>
            <img src={images.product} className="mainPic" alt="main product" />
            <div className="text">
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    {images.productPrefix && (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                height: '100%'
                            }}
                        >
                            <div
                                className="empty"
                                style={{ height: '45%' }}
                            ></div>
                            <img
                                src={images.productPrefix}
                                className="prefixPic"
                                alt="product prefix"
                            />
                        </div>
                    )}
                    <div className="quantity-container">
                        {salePercentage > 0 && (
                            <p className="stroked" style={{ height: '45%' }}>
                                {amountBeforeSale ??
                                    `${formattingNumber(
                                        calculateSaleStrokedNumber(
                                            quantity,
                                            salePercentage,
                                            salePercentageDisplayType
                                        ),
                                        quantityFormant
                                    )}`}
                            </p>
                        )}
                        <p className="quantity">{quantityDisplay}</p>
                    </div>
                </div>
            </div>
        </StyledMainProduct>
    );
}

export default BundleMainProduct;
